export default __webpack_public_path__ + "static/media/logoTransparent.6bbb74da.png";